export default {
  namespaced: true,
  action_plan: {
    validatedBy: 'Validado por',
    tasks: 'tarefas',
    userValidated: 'Usuário válido',
    validatedDate: 'Data de validação',
    validated: 'Validado',
    validate: 'Validar',
    assignUsers: 'Atribuir usuários',
    deadline: 'Data limite',
    deadlineOverdue: 'A tarefa está atrasada com {days} dia(s)',
    deadlineToday: 'A tarefa vence hoje',
    deadlineRemaining: 'Faltam {days} dia(s) para completar a tarefa',
    title: 'Plano de ação | Planos de ação',
    label: 'Plano de ação | Planos de ação',
    messages: {
      flowchart_not_ready: 'O editor do fluxograma ainda está carregando. Tente novamente em alguns segundos.',
      alarm_type_required: 'Selecione pelo menos um tipo de alarme.'
    },
    answeredDate: 'Data da resposta',
    openedDate: 'Data de abertura',
    start_modal: {
      title: 'O plano de ação "{name}" será lançado'
    },
    replace_modal: {
      title: 'O plano de ação ativo se tornará "{name}"',
      description: 'Planos de ação anteriores serão desabilitados e ficarão visíveis no histórico.',
    },
    fields: {
      name: {
        label: 'Nome do plano de ação',
        placeholder: 'Nome do plano de ação'
      },
      default: {
        label: "Plano de ação padrão"
      },
      all_alarm_types: {
        label: "Todos os alarmes ativos"
      },
      action_plan_status: {
        label: 'Status',
        options: {
          attending: 'Atendendo',
          waiting: 'Esperando',
        }
      },
    },
    nodes: {
      decision: {
        name: 'Decisão',
        config: {
          question: 'Pergunta',
          yes: 'Sim',
          no: 'Não',
          new_output: 'Resposta',
          add_output: 'Adicionar resposta',
          remove_output: 'Remover resposta',
        }
      },
      terminate: {
        name: 'Finalizar'
      }
    },
    viewer: {
      preview: "vista prévia",
      answer: 'Resposta',
      comments: "Comentários",
      execute_command: 'Executar comando',
      execute: 'Executar',
      completed: 'Pronta',
      error: 'Erro',
      continue: 'Prosseguir',
      finalized: 'Finalizado',
      start_form: 'Iniciar formulário',
      response_form_id_missing:
        'A resposta do servidor não incluiu o id do formulário. Verifique a API ou contate o suporte.',
      drag_form_hint: 'Arraste para um slot da grade para abrir o formulário aqui',
      advance: 'Avançar',
      form_not_answered: 'O formulário não foi respondido',
      form_answered_success: 'Formulário verificado com sucesso',
      executed_success: 'Comando executado com sucesso',
      executed_error: 'Ocorreu um erro ao executar o comando',
      notify: 'Notificar',
      panel_failure_title: 'Falha do painel',
      panel_failure_yes: 'Sim',
      panel_failure_no: 'Não',
      panel_failure_answered_no: 'Sem falha do painel',
      panel_failure_comment: 'Comentário da notificação',
      panel_failure_comment_hint:
        'Este comentário será enviado na notificação aos usuários com permissão de alarmes do plano de ação.',
      panel_failure_notified: 'Notificação de falha do painel enviada',
    },
    list: {
      title: 'Registro de planos de ação',
      filters: {
        tenants: 'Tenants',
        start_date: "De",
        end_date: "Para",
      },
      cols: {
        col1: 'Nome',
        col2: 'Usuário',
        col3: 'Tenant',
        col4: 'Alarme',
        col5: 'Data',
      }
    },
    documentTable: {
      name: 'Nome do Documento',
      description: 'Descrição',
      tenant: 'Tenant',
      view: 'Visualizar',
      created_at: 'Criado em',
      updated_at: 'Atualizado em'
    },
    documentActionPlan:{
      title: 'Documentos do Plano de Ação',
      addDocument: 'Adicionar documento',
      document: 'Documento',
      view: 'Visualizar',
    }
  },
}
